import { render, staticRenderFns } from "./cfsScanPack.vue?vue&type=template&id=084c3fbd&"
import script from "./cfsScanPack.vue?vue&type=script&lang=js&"
export * from "./cfsScanPack.vue?vue&type=script&lang=js&"
import style0 from "./cfsScanPack.vue?vue&type=style&index=0&id=084c3fbd&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports